/**
 * Infer device capabilities from id / API fields.
 * hub_* → hub, node_* → node, else standalone (device_001, etc.)
 */

export function inferDeviceType(deviceId, explicitType) {
  const explicit = String(explicitType || "").toLowerCase().trim();
  if (explicit === "hub" || explicit === "node" || explicit === "standalone") {
    return explicit;
  }
  const id = String(deviceId || "").toLowerCase();
  if (id.startsWith("hub_")) return "hub";
  if (id.startsWith("node_")) return "node";
  return "standalone";
}

/** Nodes never have a cloud pump UI (valve is local, driven by hub). */
export function deviceSupportsPump(deviceType) {
  return deviceType === "standalone" || deviceType === "hub";
}

/**
 * What sensor tiles to show on Devices preview.
 * Hub: no local climate sensors (motor/valves later). Readings live on pot nodes.
 * Node: temp + humidity + soil (like standalone, per pot).
 * Standalone: all three.
 */
export function devicePreviewSensors(deviceType) {
  if (deviceType === "hub") return { temp: false, humidity: false, soil: false };
  if (deviceType === "node") return { temp: true, humidity: true, soil: true };
  return { temp: true, humidity: true, soil: true };
}

/**
 * Show pump / irrigation UI only when a pump is attached.
 * Defaults: standalone = true (existing fleet), hub = false until user enables, node = false.
 */
export function resolvePumpConnected({ deviceId, deviceType, pumpConnected } = {}) {
  const type = inferDeviceType(deviceId, deviceType);
  if (!deviceSupportsPump(type)) return false;
  if (typeof pumpConnected === "boolean") return pumpConnected;
  return type === "standalone";
}

export function deviceTypeLabel(deviceType) {
  if (deviceType === "hub") return "Hub";
  if (deviceType === "node") return "Node";
  return "Device";
}
